import React from 'react'
import { listingItems } from '../data/data'
const OurListing = () => {
  return (
    <div>
         <h2 className="textblack p2 text-center">OUR LISTING</h2>
         <div className='singcon'>
                     {listingItems.map((property)=>{
                         return(
                           
                                 <div key={property.id} className="property-card">
               <div className="property-image-wrapper">
                 <img
                   src={property.image}
                   alt={property.title}
                   className="property-image"
                 />
                 <div className="property-price">{property.price}</div>
               </div>
               <div className="property-content">
                 <h3 className="property-title">{property.title}</h3>
                 <p className="property-type-location">
                   <span className="property-type">{property.type}</span> |{" "}
                   <span className="property-location">{property.location}</span>
                 </p>
                 <p className="property-description">{property.shortDescription}</p>
                 <button className="property-btn"><a className='propbtn' href={property.link} target="_blank" rel="noopener noreferrer">View Details</a></button>
               </div>
             </div>
                           
                         )
                     })}
                 </div>
    </div>
  )
}

export default OurListing